import type { LabelType } from '@common/customControls/getServiceLabel';
import type { ServiceCode } from '@common/enums';
import { ProcessEntity, ServiceType } from '@common/enums';
import type { IDiagnosticReportGetOne } from '../../interfaces/diagnosticReportGetOne';
import { fetchJson } from '../../../store/fetch';
import { CancelButton } from './CancelButton';

interface IRemoveDiagnosticReportButtonProps {
    diagnosticReport: IDiagnosticReportGetOne;
    removeDiagnosticReport?: () => Promise<void>;
    serviceCode: ServiceCode;
    toastServiceLabelType?: LabelType;
}

export function RemoveDiagnosticReportButton(props: IRemoveDiagnosticReportButtonProps) {
    if (
        !props.diagnosticReport.authorization ||
        !props.diagnosticReport.authorization.canDelete ||
        !props.removeDiagnosticReport
    ) {
        return null;
    }

    return (
        <CancelButton
            cancel={async () => await deleteDiagnosticReport()}
            entity={ProcessEntity.diagnosticReport}
            isInReadMode={true}
            serviceCode={props.serviceCode}
            serviceType={ServiceType.examination}
            toastServiceLabelType={props.toastServiceLabelType}
        />
    );

    async function deleteDiagnosticReport() {
        const url = `/api/diagnosticReports/${props.diagnosticReport.id}`;
        await fetchJson(url, 'DELETE');
        await props.removeDiagnosticReport!();
    }
}
